export default "__VITE_ASSET__CT0QerSi__"